import { ethers } from "ethers"
import { API_URL, web3ChainId, web3ChainName } from "../../constants/constants"
import { shopOrder } from "../shop"
import {
  checkApprove,
  getDecimals,
  getNetwork,
  getSigner,
  getVaultContract,
} from "../../data/smart"

import { formatMetamaskError } from "../../utils/utlis"

export const handleBoxPurchase = async (
  user,
  totalBoxes,
  quantities,
  totalPrice,
) => {
  if (totalBoxes > 0) {
    if (!window.ethereum) return alert("Metamask not found")

    const chainId = (await getNetwork()).chainId.toString()

    if (chainId !== web3ChainId) {
      // console.log(
      //   "User Chain ID: ",
      //   chainId,
      //   "Required Chain ID: ",
      //   web3ChainId,
      // )
      throw new Error(`Please switch to the "${web3ChainName}".`)
    }

    /**
     * @var {{success: boolean, error: string, order_id: int, sum: float, referrer: string|null, signature: string, nonce: string, messageHash: string}} data
     * */
    const data = await shopOrder(user.sessionToken, quantities, totalPrice)
    const userAddress = user.address

    if (!data.success) {
      throw new Error(data.error)
    }

    try {
      if (!window.ethereum) return alert("MetaMask not found")

      const decimals = await getDecimals()
      const amount = ethers.utils.parseUnits(data.sum.toString(), decimals)

      const signer = await getSigner()
      await checkApprove(amount, userAddress, signer)

      const vaultContract = await getVaultContract()

      let ref = data.referrer
      if (!ref || ref === "" || !ethers.utils.isAddress(ref)) {
        ref = "0x0000000000000000000000000000000000000000"
      }

      // console.log(
      //   "amount: " + amount,
      //   "referrer: " + ref,
      //   "nonce: " + data.nonce,
      //   "signature: " + data.signature,
      //   "gasLimit: " + 500000,
      // )

      const tx = await vaultContract.buyItem(
        amount,
        ref,
        data.nonce,
        data.signature,
        { gasLimit: 500000 },
      )
      const receipt = await tx.wait()

      await fetch(`${API_URL}/web3/transactions/save`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${user.sessionToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          hash: receipt.transactionHash,
          chain_id: chainId,
          order_id: data.order_id,
          sum: data.sum,
          type: "NftBoxPurchase",
        }),
      })

      // console.log("transactionHash:", tx.hash)
      // console.log("receipt:", receipt)

      return "Purchase successful"
    } catch (e) {
      throw new Error(formatMetamaskError(e))
    }
  }
}
